/**
 * Copyright IBM Corp. 2022, 2026
 */

import classNames from 'classnames'
import type { HTMLAttributes } from 'react'
import s from './style.module.scss'

interface BadgeCountProps extends HTMLAttributes<HTMLDivElement> {
	size?: 'small' | 'medium' | 'large'
	type?: 'filled' | 'inverted' | 'outlined'
	/**
	 * Text value that renders in the Badge Count.
	 */
	text: string
}

const BadgeCount = ({
	text,
	size = 'medium',
	type = 'filled',
	color = 'neutral',
	className,
	...rest
}: BadgeCountProps) => {
	return (
		<div
			className={classNames(
				s['badge-count'],
				s[`size-${size}`],
				s[`type-${type}`],
				s[`color-neutral`],
				className,
			)}
			{...rest}
		>
			{text}
		</div>
	)
}

BadgeCount.displayName = 'BadgeCount'

export type { BadgeCountProps }
export { BadgeCount }
